import * as exampleAmble from "./example-amble";

/**
 * UK-specific ambles for SimpleBusiness UK
 */
export const simplybusinessUkAmbles: Record<string, string> = {
  "example-amble": exampleAmble.amble,
};
